import { render, staticRenderFns } from "./Bigcoffeegathering.vue?vue&type=template&id=76b376fe&"
import script from "./Bigcoffeegathering.vue?vue&type=script&lang=js&"
export * from "./Bigcoffeegathering.vue?vue&type=script&lang=js&"
import style0 from "./Bigcoffeegathering.vue?vue&type=style&index=0&id=76b376fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports